import { MicrosoftAuthenticatorAuthenticationMode } from '@microsoft/microsoft-graph-types-beta';
import { IncludeOptionsLookups, TargetsSchema } from '../authentication-method-policy-utlity';

export interface AuthenticationMethodPolicyMicrosoftAuthenticatorSchema {
    type: 'object';
    properties: {
        state: {
            type: 'string';
            const: 'enabled' | 'disabled';
        };

        isSoftwareOathEnabled: {
            type: 'boolean';
            const: boolean;
        };

        featureSettings?: {
            type: 'object';
            properties: {
                companionAppAllowedState?: {
                    type: 'object';
                    properties: {
                        state: {
                            type: 'string';
                            const: 'default' | 'enabled' | 'disabled';
                        };
                        includeTarget: {
                            type: 'object';
                            properties: {
                                id: { type: 'string'; const: string };
                            };
                        };
                        excludeTarget: {
                            type: 'object';
                            properties: {
                                id: { type: 'string'; const: string };
                            };
                        };
                    };
                };

                displayAppInformationRequiredState?: {
                    type: 'object';
                    properties: {
                        state: {
                            type: 'string';
                            const: 'default' | 'enabled' | 'disabled';
                        };
                        includeTarget: {
                            type: 'object';
                            properties: {
                                id: { type: 'string'; const: string };
                            };
                        };
                        excludeTarget: {
                            type: 'object';
                            properties: {
                                id: { type: 'string'; const: string };
                            };
                        };
                    };
                };

                displayLocationInformationRequiredState?: {
                    type: 'object';
                    properties: {
                        state: {
                            type: 'string';
                            const: 'default' | 'enabled' | 'disabled';
                        };
                        includeTarget: {
                            type: 'object';
                            properties: {
                                id: { type: 'string'; const: string };
                            };
                        };
                        excludeTarget: {
                            type: 'object';
                            properties: {
                                id: { type: 'string'; const: string };
                            };
                        };
                    };
                };
            };
        };

        includeTargets?: TargetsSchema;

        excludeTargets: TargetsSchema;
    };
}

export interface AuthenticationMethodPolicyMicrosoftAuthenticatorForm {
    state: 'enabled' | 'disabled';
    isSoftwareOathEnabled: boolean;
    includeTargets: {
        groupInclusion: boolean;
        includedGroups: { id: string; authenticationMode: MicrosoftAuthenticatorAuthenticationMode }[];
    };

    featureSettings: {
        companionAppAllowedState: {
            state: 'default' | 'enabled' | 'disabled';
            includeTarget: {
                id: string;
            };
            excludeTarget: {
                id: string;
            };
        };
        displayAppInformationRequiredState: {
            state: 'default' | 'enabled' | 'disabled';
            includeTarget: {
                id: string;
            };
            excludeTarget: {
                id: string;
            };
        };

        displayLocationInformationRequiredState: {
            state: 'default' | 'enabled' | 'disabled';
            includeTarget: {
                id: string;
            };
            excludeTarget: {
                id: string;
            };
        };
    };

    excludeTargets: string[];
}

export const microsoftAuthenticatorIncludeOptionsLookups: IncludeOptionsLookups[] = [
    {
        name: 'Authentication mode',
        key: 'authenticationMode',
        options: [
            { value: 'any', label: 'Any' },
            { value: 'deviceBasedPush', label: 'Passwordless' },
            { value: 'push', label: 'Push' },
        ],
    },
];
